import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";

const SessionSequenceDialogs = ({
  alerta,
  setAlerta,
  descripcionActiva,
  filaEditando,
  openConfirmSalir,
  setOpenConfirmSalir,
  sesionARegenerar,
  setSesionARegenerar,
  openConfirmRegenerarTodo,
  setOpenConfirmRegenerarTodo,
  openDescripcion,
  setOpenDescripcion,
  openEdit,
  setOpenEdit,
  onBack,
  onConfirmRegenerateRow,
  onRegenerateAll,
  onSaveEdit,
  setFilaEditando,
}) => (
  <>
    <Dialog open={openConfirmSalir} onClose={() => setOpenConfirmSalir(false)}>
      <DialogTitle>¿Salir sin guardar cambios?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
          Tienes cambios sin guardar.
          <br /><br />
          Si sales ahora, se perderán los ajustes realizados en los títulos y descripciones.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenConfirmSalir(false)}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={() => { setOpenConfirmSalir(false); onBack(); }}>
          Salir sin guardar
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={Boolean(sesionARegenerar)} onClose={() => setSesionARegenerar(null)}>
      <DialogTitle>Regenerar sesión {sesionARegenerar?.nroSesion}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Se volverá a generar el título y la descripción de esta sesión. Los cambios manuales se perderán.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setSesionARegenerar(null)}>Cancelar</Button>
        <Button variant="contained" onClick={onConfirmRegenerateRow}>Regenerar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openConfirmRegenerarTodo} onClose={() => setOpenConfirmRegenerarTodo(false)}>
      <DialogTitle>Regenerar todos los temas</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
          Esta acción volverá a generar <strong>todos los títulos y descripciones</strong> de la secuencia.
          <br />
          Los cambios realizados manualmente que no hayan sido guardados se perderán.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenConfirmRegenerarTodo(false)}>Cancelar</Button>
        <Button variant="contained" onClick={onRegenerateAll}>Regenerar todo</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openDescripcion} onClose={() => setOpenDescripcion(false)} maxWidth="md" fullWidth>
      <DialogTitle>Sesión {descripcionActiva?.nroSesion}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>{descripcionActiva?.tema}</Typography>
        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>{descripcionActiva?.descripcion}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDescripcion(false)}>Cerrar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openEdit} onClose={() => setOpenEdit(false)} maxWidth="md" fullWidth className="step4-dialog">
      <DialogTitle className="step4-dialog-title">Editar Sesión</DialogTitle>
      <DialogContent className="step4-dialog-content" sx={{ overflow: "visible" }}>
        <TextField
          fullWidth
          label="Sesión"
          margin="dense"
          sx={{ mb: 2 }}
          value={filaEditando?.tema || ""}
          onChange={(event) => setFilaEditando({ ...filaEditando, tema: event.target.value })}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Descripción"
          margin="dense"
          value={filaEditando?.descripcion || ""}
          onChange={(event) => setFilaEditando({ ...filaEditando, descripcion: event.target.value })}
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions className="step4-dialog-actions">
        <Button onClick={() => setOpenEdit(false)} className="step4-btn step4-btn-back">Cancelar</Button>
        <Button variant="contained" onClick={onSaveEdit} className="step4-btn step4-btn-regenerate">Guardar</Button>
      </DialogActions>
    </Dialog>

    <Snackbar open={alerta.open} autoHideDuration={3000} onClose={() => setAlerta({ ...alerta, open: false })}>
      <Alert severity={alerta.tipo}>{alerta.mensaje}</Alert>
    </Snackbar>
  </>
);

export default SessionSequenceDialogs;
